/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Kantor_S1Inputs */

const en_tut_kantor_s1 = /** @type {(inputs: Tut_Kantor_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open **Kantor virtual** in the left menu. Even before entering you can see the map in **Pratinjau kantor** mode.`)
};

const id_tut_kantor_s1 = /** @type {(inputs: Tut_Kantor_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka **Kantor virtual** di menu kiri. Sebelum masuk Anda sudah bisa melihat peta dalam mode **Pratinjau kantor**.`)
};

/**
* | output |
* | --- |
* | "Open **Kantor virtual** in the left menu. Even before entering you can see the map in **Pratinjau kantor** mode." |
*
* @param {Tut_Kantor_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_kantor_s1 = /** @type {((inputs?: Tut_Kantor_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Kantor_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_kantor_s1(inputs)
	return en_tut_kantor_s1(inputs)
});